<template>
 <div class="dflexc-jcs terrain-selection">
  <h4>Terrain Selection</h4>
  <div class="dflexr-jcsa ter-sel-row">
    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'City'"
                     :terrain_group="0"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Village'"
                     :terrain_group="0"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Town'"
                     :terrain_group="0"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Meadow'"
                     :terrain_group="1"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Valley'"
                     :terrain_group="1"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Prairie'"
                     :terrain_group="1"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Forest'"
                     :terrain_group="2"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Jungle'"
                     :terrain_group="2"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Wooded'"
                     :terrain_group="2"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Mountain'"
                     :terrain_group="3"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Hilly'"
                     :terrain_group="3"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Rocky'"
                     :terrain_group="3"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Desert'"
                     :terrain_group="4"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Tundra'"
                     :terrain_group="4"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Badlands'"
                     :terrain_group="4"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcs ter-col cvt-col">
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Sea'"
                     :terrain_group="5"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'Marsh'"
                     :terrain_group="5"
                     :selected_ter="selectedTerrain"          />
      <TerrainSelRow @ter_selection="changeTerrain" :lbl="'River'"
                     :terrain_group="5"
                     :selected_ter="selectedTerrain"          />
    </div>

    <div class="dflexc-jcc btn gen-encounter" id="btn-gen-encounter"
         @click="gen_encounter">
      Generate Encounter
    </div>


  </div>
</div>
</template>

<script setup>
import {computed, ref} from "vue";
import TerrainSelRow from '@/components/encounter/terrain_sel_row.vue'

const zap = defineEmits(['generate'])
const selectedTerrain = ref('City')
let terrainGroup = 0

const changeTerrain = (terrain) => {
  terrainGroup = terrain.slice(-1)
  selectedTerrain.value = terrain.slice(0, -1)
}


const gen_encounter = () => {
  zap('generate', terrainGroup, selectedTerrain.value)
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/encounter-view-panel";
</style>
